/* Selector de packs. Mientras Kaching no esté instalada, el pack solo cambia
   la cantidad que se manda al carrito: el producto tiene una sola variante.
   Quien aplica el descuento es el carrito, no la ficha. */
document.addEventListener('click', function (e) {
  var pack = e.target.closest('[data-ond-pack]');
  if (!pack) return;

  var grupo = pack.closest('[data-ond-packs]');
  grupo.querySelectorAll('[data-ond-pack]').forEach(function (b) {
    var activo = b === pack;
    b.classList.toggle('is-on', activo);
    b.setAttribute('aria-checked', activo ? 'true' : 'false');
  });

  var raiz = grupo.closest('[data-ond-buy]') || document;

  var cantidad = raiz.querySelector('input[name="quantity"]');
  if (cantidad) cantidad.value = pack.dataset.qty || '1';

  raiz.querySelectorAll('[data-ond-price]').forEach(function (el) {
    el.textContent = pack.dataset.price || '';
  });
  raiz.querySelectorAll('[data-ond-compare]').forEach(function (el) {
    el.textContent = pack.dataset.compare || '';
    el.hidden = !pack.dataset.compare;
  });
});
